// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"7180ff39","453":"882d0511","928":"ae5bf25b"}[chunkId] + ".chunk.js";
};